import IconListen from 'approot/shared/icons/icon-listen';
import Spinner from 'approot/shared/spinner/spinner';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';

type Props = {
  loadingAudio: boolean;
  onClick: () => void;
};

const TTSListenButton = ({ onClick, loadingAudio }: Props) => {
  return (
    <SecondaryButton
      type="button"
      $withIcon
      $borderRadius={40}
      data-tts="true"
      data-testid="tts-listen-button"
      onClick={async e => {
        e.stopPropagation();
        onClick();
      }}
      data-selector="btn-tts-listen"
    >
      {loadingAudio ? (
        <>
          <Spinner />
          <span>Loading audio</span>
        </>
      ) : (
        <>
          <IconListen width={20} height={20} />
          <span>Listen</span>
        </>
      )}
    </SecondaryButton>
  );
};

export default TTSListenButton;
